import cpf from './cpf';
import cnpj from './cnpj';

function count(value) {
  return String(value).replace(/\D/g, '').length;
}

export default function cpfOrCnpj(value = '', options = {}) {
  if (count(value) < 11 || count(value) > 14) {
    return true;
  }

  const fn = count(value) <= 11 ? cpf : cnpj;

  return fn(value, options);
}

cpfOrCnpj.message = function message(value, options = {}) {
  const fn = count(value) <= 11 ? cpf : cnpj;

  return options.message || fn.message(value, options);
};
